import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { getLanguage } from "../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { newsUserDetails, userDetails } from "../../utils";
import { setNewsUser } from "../../containers/console/redux/actions";
import { Button } from "..";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";

const lan = getLanguage();

const Index = ({ data, onClick, onClickPublish, onClickLogOut }) => {
  let inputElement = null;
  const history = useHistory();

  const dispatch = useDispatch();

  const { adsUserDetails } = useSelector(
    ({ adsUserReducer }) => adsUserReducer
  );

  const { newsUser } = useSelector(({ consoleReducer }) => consoleReducer);

  const [location, setLocation] = useState("Fetching location...");
  const [dateTime, setDateTime] = useState("");
  const [userData, setUserData] = useState("");

  // Get user location using IP-based geolocation
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        setLocation(`${data.city}, ${data.region}`);
      })
      .catch(() => setLocation("Location not available"));
  }, []);

  // Update date and time every second
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const formatted = now.toLocaleString("en-US", {
        weekday: "long",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
      setDateTime(formatted.replace(",", " -"));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   if (newsUser?.company_id) {
  //     setUserData(newsUser);
  //   }
  // }, [newsUser]);

  const toggleLanguage = () => {
    const newLang = lan === "en" ? "si" : "en";
    const currentPath = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("lang", newLang);
    const newUrl = `${currentPath}?${searchParams.toString()}`;
    window.location.href = newUrl;
  };

  useEffect(() => {
    let companyUser = newsUserDetails();
    if (companyUser?.company_id) {
      dispatch(setNewsUser(companyUser));
    }
  }, []);

  useEffect(() => {
    let admin = userDetails();
    console.log({ admin });
    if (admin) {
      setUserData(admin);
    }
  }, []);

  // const onClickLogOut = async () => {
  //   userLogOut();
  //   props.history.push("/sign-in");
  // };

  inputElement = (
    <>
      <div className={`top-menu-wrapper ${data.size}`} onClick={onClick}>
        {data.isLanguage && (
          <>
            {/* <img
              src={require("../../assets/img/youtube.png")}
              alt={"logo"}
              style={{ marginRight: "17px" }}
            /> */}
            {/* <img src={require("../../assets/img/facebook.png")} alt={"logo"} /> */}
            <div className={"cw__tw-language"}>
              <span
                className={lan === "en" ? "sinhala" : ""}
                onClick={async (e) => {
                  window.open("https://english.hopeofanewera.org");
                }}
              >
                English
              </span>{" "}
              |{" "}
              <span
                className={lan === "si" ? "sinhala" : ""}
                onClick={async (e) => {
                  window.open("https://sinhala.hopeofanewera.org");
                }}
              >
                සිංහල
              </span>
            </div>
            {/* <div className={"cw__tw-language"} onClick={onClickPublish}>
             Publisher
            </div> */}
            <div className="log-button">
              <Button
                data={{
                  btnName: "LOGIN",
                  buttonType: "red-border",
                  buttonSize: "xs-xs",
                  // isLoading: isLoading,
                  // disable: isDisable,
                }}
                onClick={async (e) => {
                  e.preventDefault(e);
                  // data.history.push("/subscribe");
                  window.open(`/sign-in`);
                }}
              />
              <Button
                data={{
                  btnName: "SIGNUP",
                  buttonType: "primary",
                  buttonSize: "xs-xs",
                  // isLoading: isLoading,
                  // disable: isDisable,
                }}
                onClick={async (e) => {
                  e.preventDefault(e);
                  // data.history.push("/subscribe");
                  window.open(`/ads/sign-up`);
                }}
              />
            </div>
          </>
        )}
        {/* {data.isLanguage && (
          <div className="top-bar"> */}
        {/*<span>{location}</span>*/}
        {/*<div className="divider" />*/}
        {/*<span>{dateTime}</span>*/}
        {/*{userData?.company_name && (*/}
        {/*  <>*/}
        {/*    <div className="divider" />*/}
        {/*    <span>Hi, {userData?.company_name}</span>*/}
        {/*  </>*/}
        {/*)}*/}
        {/*<div className="sub-button">*/}
        {/*  <Button*/}
        {/*    data={{*/}
        {/*      btnName: "SUBSCRIBE",*/}
        {/*      buttonType: "primary",*/}
        {/*      buttonSize: "xs",*/}
        {/*      // isLoading: isLoading,*/}
        {/*      // disable: isDisable,*/}
        {/*    }}*/}
        {/*    onClick={async (e) => {*/}
        {/*      e.preventDefault(e);*/}
        {/*      // data.history.push("/subscribe");*/}
        {/*      window.open(`/subscribe`);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</div>*/}
        {/* </div>
        )} */}

        {data.isLogo && !data.isAds && (
          <div className={"tmw__logo"}>
            <img src={require("../../assets/img/logo_1.png")} alt={"logo"} />
          </div>
        )}
        {data.isLogo && data.isAds && (
          <div className={"tmw__ads_logo"}>
            <img src={require("../../assets/img/lgo.png")} alt={"logo"} />
          </div>
        )}

        {data.isProfile && (
          <div className={"tmw__profile"}>
            Hi , {adsUserDetails?.company_name || userData?.username}{" "}
            <div className={"tmwp__logout"} onClick={onClickLogOut}>
              Log out
            </div>
          </div>
        )}
      </div>
    </>
  );

  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultProps = {};
export default withRouter(Index);
